export default "/_next/static/assets/defaultBackgroundImageMobile_d771a9aea9e5ee56815c0d3d10d64956.jpg";